"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../Constants");
const plugins_1 = require("./plugins");
const Cesium = window.Cesium;
class FlightpathHandler extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.debug = Constants_1.Constants.debug_off;
        this.show = true;
        this.coords = null;
        this.maxHeight = 0;
        this.minHeight = 99999999;
        this.coordHelper = null;
    }
    init() {
        this.coordHelper = this.services.coordHelper;
    }
    updateCoordsFromPhotos(photos) {
        let points = [];
        photos.forEach(p => {
            let c = null;
            if (c = p['canonicalCoords']) {
                points.push(c);
                if (c.height && c.height > this.maxHeight) {
                    this.maxHeight = c.height;
                }
                if (c.height && c.height < this.minHeight) {
                    this.minHeight = c.height;
                }
            }
        });
        this.coords = points;
        this.updateCoords();
    }
    updateCoords(coords = null) {
        if (coords) {
            this.coords = coords;
        }
        this.wipe();
        if (this.coords && this.coords.length > 0) {
            this.entity('primary', this.services.mapService.viewer.entities.add({
                name: 'flightpath : polyline',
                show: this.show,
                polyline: {
                    positions: this.coordHelper.toCartesians(this.coords),
                    width: 6,
                    material: new Cesium.PolylineDashMaterialProperty({
                        color: Cesium.Color.WHITE.withAlpha(0.5),
                        gapColor: Cesium.Color.WHITE.withAlpha(0.7),
                        dashLength: 12,
                    }),
                }
            }));
            this.showHide();
        }
    }
}
FlightpathHandler.meta = {
    label: 'PLUGINS.FLIGHTPATH.LABEL',
    name: 'flightpath-handler',
    translator: 'PLUGINS.FLIGHTPATH',
    tooltip: 'PLUGINS.FLIGHTPATH.TOOLTIP',
    category: plugins_1.FdmPlugin.category.beta,
    types: [plugins_1.FdmPlugin.types.coordController]
};
exports.FlightpathHandler = FlightpathHandler;
